import { render } from "./PasswordExpirationDialog.vue?vue&type=template&id=3bfea643&scoped=true"
import script from "./PasswordExpirationDialog.vue?vue&type=script&lang=ts"
export * from "./PasswordExpirationDialog.vue?vue&type=script&lang=ts"

import "./PasswordExpirationDialog.vue?vue&type=style&index=0&id=3bfea643&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3bfea643"

export default script